import React from "react"
import styled from "styled-components"
import SignUpForm from "./SignInForm"

export default function LoginView() {
  return (
    <Wrapper>
      <SignUpForm />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
`
